import React, { useState, useEffect, useRef } from "react";
import _ from "lodash";
import {
    Grid,
    Button,
    FormControl,
    TextField,
    Paper,
    Typography,
    Select,
    MenuItem,
    List,
    ListItem,
    ListItemText,
} from "@material-ui/core";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { noImg } from "vrcore-dashboard/dist/utilities";
import AddBoxIcon from "@material-ui/icons/AddBox";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import styled from "styled-components";

const TitleTypography = styled(Typography)`
    width: fit-content !important;
    margin: auto !important;
    margin-top: 25px !important;
    margin-bottom: 25px !important;
`;

const StyledGrid = styled(Grid)`
    margin-top: 30px !important;
    margin-bottom: 30px !important;
    margin-left: 20px !important;
    margin-right: 20px !important;
`;

const UploadButton = styled(Button)`
    width: 150px;
`;
const EditQualificationInfoModal = (props) => {
    const [selectedPhotoModal, setSelectedPhotoModal] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState("");
    const [modalState, setModalState] = useState(props.modalState);
    const [qualification, setQualification] = useState(
        props.selectedQualification
    );

    const [qualificationImageBlobOne, setQualificationImageBlobOne] = useState(
        false
    );
    const [qualificationImageBlobTwo, setQualificationImageBlobTwo] = useState(
        false
    );
    const [uid, setUID] = useState(props.userUID);
    const photoUploadRef1 = useRef();
    const photoUploadRef2 = useRef();
    const UploadFileRef = useRef();
    useEffect(() => {
        setModalState(props.modalState);
        setQualification(props.selectedQualification);
        setUID(props.userUID);
    }, [props.modalState, props.selectedQualification, props.userUID]);

    return (
        <>
            <Modal isOpen={modalState}>
                {qualification && (
                    <Paper style={{ width: "fit-content" }}>
                        <ModalHeader>Edit Qualification</ModalHeader>
                        <img
                            alt="qualification valid"
                            src={qualification.qualification_valid_img}
                            style={{
                                width: "100px",
                                height: "98px",
                                margin: "0 auto",
                                position: "relative",
                                display: "block",
                            }}
                        />
                        <TitleTypography variant="h6">
                            {qualification.qualification_title}
                        </TitleTypography>

                        {qualification.qualification_exp_date === "N/A" &&
                            qualification.qualification_verified === "N/A" &&
                            qualification.qualification_reg_num === "N/A" &&
                            qualification.qualification_img === "N/A" && (
                                <div>
                                    <Typography
                                        style={{
                                            marginTop: 15,
                                            marginLeft: "25%",
                                        }}
                                        variant="title"
                                    >
                                        Nothing To Edit
                                    </Typography>
                                    <Button
                                        style={{
                                            marginTop: 40,
                                            marginBottom: 15,
                                            marginLeft: "50%",
                                        }}
                                        variant="contained"
                                        color="primary"
                                        onClick={() => {
                                            props.setModalState(false);
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            )}
                        {(qualification.qualification_exp_date !== "N/A" ||
                            qualification.qualification_exp_date !== "Req." ||
                            qualification.qualification_verified !== "N/A" ||
                            qualification.qualification_reg_num !== "N/A" ||
                            qualification.qualification_img !== "N/A") && (
                            <div>
                                <StyledGrid spacing={7} container>
                                    {(qualification.qualification_exp_date !==
                                        "N/A" ||
                                        qualification.qualification_exp_date !==
                                            "Req.") && (
                                        <Grid
                                            style={{
                                                display: "block",
                                                marginTop: "-30px",
                                            }}
                                            item
                                            xs={12}
                                            xl={12}
                                        >
                                            <FormControl
                                                style={{
                                                    display:
                                                        "-webkit-inline-box;",
                                                    flexDirection: "inherit",
                                                    marginLeft: "132px",
                                                }}
                                            >
                                                <p>
                                                    Expiry
                                                    Date:&nbsp;&nbsp;&nbsp;
                                                </p>
                                                <DayPickerInput
                                                    value={
                                                        qualification.qualification_exp_date
                                                    }
                                                    placeholder="Expiry Date"
                                                    formatDate={formatDate}
                                                    parseDate={parseDate}
                                                    format="DD/MM/YYYY"
                                                    onDayChange={(day) => {
                                                        setQualification({
                                                            ...qualification,
                                                            qualification_exp_date: moment(
                                                                day,
                                                                "DD/MM/YYYY"
                                                            ).format(
                                                                "DD/MM/YYYY"
                                                            ),
                                                        });
                                                    }}
                                                />
                                            </FormControl>
                                        </Grid>
                                    )}
                                    {qualification.qualification_verified !==
                                        "N/A" && (
                                        <Grid
                                            item
                                            xs={12}
                                            xl={12}
                                            style={{ marginTop: "-30px" }}
                                        >
                                            <FormControl
                                                style={{
                                                    display:
                                                        "-webkit-inline-box;",
                                                    flexDirection: "inherit",
                                                    marginLeft: "132px",
                                                }}
                                            >
                                                <p>
                                                    Verification:&nbsp;&nbsp;&nbsp;
                                                </p>
                                                <Select
                                                    style={{ width: "183px" }}
                                                    value={
                                                        qualification.qualification_verified ===
                                                        ""
                                                            ? "No"
                                                            : qualification.qualification_verified
                                                    }
                                                    onChange={(event) => {
                                                        setQualification({
                                                            ...qualification,
                                                            qualification_verified:
                                                                event.target
                                                                    .value,
                                                        });
                                                    }}
                                                >
                                                    <MenuItem value={"Yes"}>
                                                        Yes
                                                    </MenuItem>
                                                    <MenuItem value={"No"}>
                                                        No
                                                    </MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    )}
                                    {qualification.qualification_reg_num !==
                                        "N/A" && (
                                        <Grid
                                            xs={12}
                                            xl={12}
                                            style={{
                                                marginTop: "-30px",
                                                display: "contents",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    marginTop: "21px",
                                                    marginLeft: "132px",
                                                }}
                                            >
                                                Registration
                                                Number:&nbsp;&nbsp;&nbsp;
                                            </p>
                                            <TextField
                                                value={
                                                    qualification.qualification_reg_num
                                                }
                                                label="Registration Number"
                                                onChange={(event) => {
                                                    setQualification({
                                                        ...qualification,
                                                        qualification_reg_num:
                                                            event.target.value,
                                                    });
                                                }}
                                            />
                                        </Grid>
                                    )}
                                    {qualification.qualification_img !==
                                        "N/A" && (
                                        <Grid xs={10} xl={10} item>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <div>
                                                    <Typography
                                                        variant="body2"
                                                        style={{
                                                            marginLeft: "95px",
                                                        }}
                                                    >
                                                        Front View
                                                    </Typography>

                                                    <img
                                                        style={{
                                                            width: "250px",
                                                            height: "220px",
                                                            margin: "10px",
                                                            border:
                                                                "2px solid #0188cc",
                                                            borderRadius: "5px",
                                                        }}
                                                        src={
                                                            qualification.qualification_img ===
                                                                "" ||
                                                            qualification.qualification_img ===
                                                                "N/A"
                                                                ? noImg
                                                                : qualification.qualification_img
                                                        }
                                                        onClick={() => {
                                                            setSelectedPhotoModal(
                                                                true
                                                            );
                                                            setSelectedPhoto(
                                                                qualification.qualification_img
                                                            );
                                                        }}
                                                        alt="Qualification Expiry Date Img1"
                                                    />
                                                    <div
                                                        style={{
                                                            marginTop: 15,
                                                        }}
                                                    >
                                                        <input
                                                            type="file"
                                                            id="file"
                                                            accept="image/jpeg, image/png"
                                                            ref={
                                                                photoUploadRef1
                                                            }
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            onChange={(
                                                                event
                                                            ) => {
                                                                setQualification(
                                                                    {
                                                                        ...qualification,
                                                                        qualification_img: URL.createObjectURL(
                                                                            event
                                                                                .target
                                                                                .files[0]
                                                                        ),
                                                                    }
                                                                );

                                                                setQualificationImageBlobOne(
                                                                    event.target
                                                                        .files[0]
                                                                );
                                                            }}
                                                        />
                                                        <AddBoxIcon
                                                            color="#0188cc"
                                                            onClick={() => {
                                                                photoUploadRef1.current.click();
                                                            }}
                                                            style={{
                                                                margin:
                                                                    "inherit",
                                                                color:
                                                                    "#0188cc",
                                                                height: "50px",
                                                                width: "50px",
                                                                marginLeft:
                                                                    "10px",
                                                            }}
                                                        ></AddBoxIcon>
                                                        <Typography
                                                            style={{
                                                                margin:
                                                                    "inherit",
                                                            }}
                                                            variant="body2"
                                                        >
                                                            Upload Image
                                                        </Typography>
                                                        <br />
                                                        {qualification.qualification_img !==
                                                            "" && (
                                                            <UploadButton
                                                                variant="outlined"
                                                                // color=""
                                                                style={{
                                                                    backgroundColor:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    setQualification(
                                                                        {
                                                                            ...qualification,
                                                                            qualification_img:
                                                                                "",
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Remove Image
                                                            </UploadButton>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    <Typography
                                                        variant="body2"
                                                        style={{
                                                            marginLeft: "95px",
                                                        }}
                                                    >
                                                        Back View{" "}
                                                    </Typography>
                                                    <img
                                                        style={{
                                                            width: "250px",
                                                            height: "220px",
                                                            margin: "10px",
                                                            border:
                                                                "2px solid #0188cc",
                                                            borderRadius: "5px",
                                                        }}
                                                        src={
                                                            qualification.qualification_img_2 ===
                                                                "" ||
                                                            qualification.qualification_img_2 ===
                                                                "N/A" ||
                                                            qualification.qualification_img_2 ===
                                                                undefined
                                                                ? noImg
                                                                : qualification.qualification_img_2
                                                        }
                                                        onClick={() => {
                                                            setSelectedPhotoModal(
                                                                true
                                                            );
                                                            setSelectedPhoto(
                                                                qualification.qualification_img_2
                                                            );
                                                        }}
                                                        alt="Qualification Expiry Date Img2"
                                                    />
                                                    <div
                                                        style={{
                                                            marginTop: 15,
                                                        }}
                                                    >
                                                        <input
                                                            type="file"
                                                            id="file"
                                                            accept="image/jpeg, image/png"
                                                            ref={
                                                                photoUploadRef2
                                                            }
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            onChange={(
                                                                event
                                                            ) => {
                                                                setQualification(
                                                                    {
                                                                        ...qualification,
                                                                        qualification_img_2: URL.createObjectURL(
                                                                            event
                                                                                .target
                                                                                .files[0]
                                                                        ),
                                                                    }
                                                                );
                                                                setQualificationImageBlobTwo(
                                                                    event.target
                                                                        .files[0]
                                                                );
                                                            }}
                                                        />
                                                        <AddBoxIcon
                                                            color="#0188cc"
                                                            onClick={() => {
                                                                photoUploadRef2.current.click();
                                                            }}
                                                            style={{
                                                                margin:
                                                                    "inherit",
                                                                color:
                                                                    "#0188cc",
                                                                height: "50px",
                                                                width: "50px",
                                                                marginLeft:
                                                                    "10px",
                                                            }}
                                                        ></AddBoxIcon>
                                                        <Typography
                                                            style={{
                                                                margin:
                                                                    "inherit",
                                                            }}
                                                            variant="body2"
                                                        >
                                                            Upload Image
                                                        </Typography>
                                                        <br />
                                                        {qualification.qualification_img_2 !==
                                                            "" && (
                                                            <UploadButton
                                                                variant="outlined"
                                                                color="error"
                                                                style={{
                                                                    backgroundColor:
                                                                        "red",
                                                                    color:
                                                                        "white",
                                                                }}
                                                                onClick={() => {
                                                                    setQualification(
                                                                        {
                                                                            ...qualification,
                                                                            qualification_img_2:
                                                                                "",
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Remove Image
                                                            </UploadButton>
                                                        )}
                                                    </div>
                                                    <br />
                                                    <br />
                                                    <div>
                                                        <React.Fragment>
                                                            <input
                                                                accept="application/pdf"
                                                                type="file"
                                                                multiple
                                                                onChange={(
                                                                    event
                                                                ) => {
                                                                    let attached_files =
                                                                        _.get(
                                                                            qualification,
                                                                            "attached_files"
                                                                        ) || [];
                                                                    Object.keys(
                                                                        event
                                                                            .target
                                                                            .files
                                                                    ).map(
                                                                        async (
                                                                            file_index
                                                                        ) => {
                                                                            if (
                                                                                event
                                                                                    .target
                                                                                    .files[
                                                                                    file_index
                                                                                ]
                                                                                    .size <
                                                                                10000000
                                                                            )
                                                                                await props.uploadFile(
                                                                                    event
                                                                                        .target
                                                                                        .files[
                                                                                        file_index
                                                                                    ],
                                                                                    "qualification_documents",
                                                                                    (
                                                                                        status
                                                                                    ) => {},
                                                                                    (
                                                                                        newFile
                                                                                    ) => {
                                                                                        attached_files = [
                                                                                            ...attached_files,
                                                                                            newFile,
                                                                                        ];
                                                                                        setQualification(
                                                                                            {
                                                                                                ...qualification,
                                                                                                attached_files,
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                );
                                                                            else
                                                                                this.setState(
                                                                                    {
                                                                                        maxSizeExceeded: true,
                                                                                    }
                                                                                );
                                                                            return true;
                                                                        }
                                                                    );
                                                                }}
                                                                style={{
                                                                    display:
                                                                        "none",
                                                                }}
                                                                ref={
                                                                    UploadFileRef
                                                                }
                                                            />
                                                            <Button
                                                                fullWidth
                                                                style={{
                                                                    width:
                                                                        "100%",
                                                                    display:
                                                                        "inline",
                                                                    color:
                                                                        "white",
                                                                    backgroundColor:
                                                                        "#0188cc",
                                                                }}
                                                                onClick={() => {
                                                                    UploadFileRef.current.click();
                                                                }}
                                                                variant="contained"
                                                            >
                                                                + Upload File
                                                            </Button>
                                                            <br />
                                                            {qualification.attached_files && (
                                                                <List>
                                                                    {qualification.attached_files.map(
                                                                        (e) => {
                                                                            return (
                                                                                <ListItem>
                                                                                    <ListItemText
                                                                                        primary={
                                                                                            e.file
                                                                                        }
                                                                                    />
                                                                                </ListItem>
                                                                            );
                                                                        }
                                                                    )}
                                                                </List>
                                                            )}
                                                        </React.Fragment>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                    )}
                                </StyledGrid>
                                <ModalFooter>
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            props.setModalState(false);
                                            props.setSelectedQualification(
                                                false
                                            );
                                            setQualificationImageBlobOne(false);
                                            setQualificationImageBlobTwo(false);
                                        }}
                                    >
                                        Close
                                    </Button>
                                    <Button
                                        variant="contained"
                                        style={{
                                            marginLeft: "25px",
                                            background: "#0188cc",
                                            color: "white",
                                        }}
                                        color="primary"
                                        onClick={() => {
                                            props.setUpdateQualInfo(
                                                qualification.qualification_id,
                                                uid,
                                                qualification,
                                                qualificationImageBlobOne,
                                                qualificationImageBlobTwo
                                            );
                                            props.setModalState(false);
                                            setQualificationImageBlobOne(false);
                                            setQualificationImageBlobTwo(false);
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </ModalFooter>
                            </div>
                        )}
                    </Paper>
                )}
            </Modal>
            <Modal isOpen={selectedPhotoModal}>
                <ModalHeader>Qualification Image</ModalHeader>
                <ModalBody>
                    <img
                        src={selectedPhoto}
                        alt="NoImage"
                        style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: 10,
                        }}
                    />
                </ModalBody>
                <ModalFooter>
                    <div>
                        <Button
                            onClick={() => {
                                setSelectedPhotoModal(false);
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};
export default EditQualificationInfoModal;
